module.exports = __webpack_public_path__ + "img/data_moun_cn.0f65afef.png";